import { Field as _Field } from '@hrlogics/react-components/form';

/** @deprecated use `Field` component from `@hrlogics/react-components/form` package */
export const Field = _Field;
